(function () {
  'use strict';

  function normalized(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/[×″”]/g, 'x').replace(/[^a-z0-9]/g, '');
  }

  function sizeKey(value) {
    var match = String(value).match(/(\d+)\s*(?:["″”]|inches|in)?\s*[x×]\s*(\d+)/i);
    return match ? match[1] + 'x' + match[2] : '';
  }

  function booleanOption(value, label) {
    var key = normalized(value);
    if (['yes', 'included', 'with', normalized(label), 'with' + normalized(label)].includes(key)) return true;
    if (['no', 'none', 'without', 'standard', 'without' + normalized(label)].includes(key)) return false;
    return null;
  }

  // Never choose a variant by price or by its position in the catalog.
  function matches(product, variant, selection) {
    if (!['12x16', '12x18', '12x20'].includes(selection.size)) return false;
    var config = variant.configuration;
    if (config && typeof config === 'object') {
      if (config.design !== selection.design || config.size !== selection.size ||
          config.groove !== selection.groove || config.engraving !== selection.engraving) return false;
      if (config.woods) {
        var slots = Object.keys(selection.woods);
        if (Object.keys(config.woods).length !== slots.length || !slots.every(function (slot) {
          return normalized(config.woods[slot]) === normalized(selection.woods[slot]);
        })) return false;
      }
      return true;
    }
    if (product.design !== selection.design) return false;
    var seenSize = false;
    var seenGroove = false;
    var seenEngraving = false;
    var valid = product.options.every(function (name, index) {
      var value = variant.options[index];
      var key = normalized(name);
      if (['size', 'dimensions', 'boardsize'].includes(key)) {
        seenSize = true;
        return sizeKey(value) === selection.size;
      }
      if (['juicegroove', 'groove'].includes(key)) {
        seenGroove = true;
        return booleanOption(value, 'juice groove') === selection.groove;
      }
      if (['engraving', 'laserengraving', 'personalengraving'].includes(key)) {
        seenEngraving = true;
        return booleanOption(value, 'engraving') === selection.engraving;
      }
      var slot = Object.keys(selection.woods).find(function (woodSlot) {
        return normalized(woodSlot) === key || normalized(woodSlot + ' wood') === key;
      });
      if (!slot && ['wood', 'woodtype', 'woodspecies'].includes(key) && Object.keys(selection.woods).length === 1) {
        slot = Object.keys(selection.woods)[0];
      }
      return !!slot && normalized(selection.woods[slot]) === normalized(value);
    });
    return valid && seenSize && (seenGroove || !selection.groove) && (seenEngraving || !selection.engraving);
  }

  function resolve(catalog, selection, productId) {
    var candidates = [];
    catalog.products.forEach(function (product) {
      if (String(product.id) !== String(productId)) return;
      product.variants.forEach(function (variant) {
        if (matches(product, variant, selection)) candidates.push(variant);
      });
    });
    return candidates.length === 1 ? candidates[0] : null;
  }

  // Export only the pure resolver for local regression tests.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { matches: matches, resolve: resolve, sizeKey: sizeKey };
    return;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-board-shop]').forEach(function (shop) {
      if (shop.dataset.checkoutReady) return;
      var catalogElement = shop.querySelector('[data-board-catalog]');
      if (!catalogElement) return;
      var catalog;
      try { catalog = JSON.parse(catalogElement.textContent); } catch (error) { return; }
      shop.dataset.checkoutReady = 'true';
      var currency = catalog.currency;
      var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency });
      var root = catalog.root.endsWith('/') ? catalog.root : catalog.root + '/';

      shop.querySelectorAll('[data-board-panel]').forEach(function (panel) {
        var customizer = panel.querySelector('.dms-cutting-board-customizer');
        var form = panel.querySelector('form');
        if (!customizer || !form) return;
        var status = panel.querySelector('[data-board-purchase-status]');
        var express = panel.querySelector('[data-board-express]');
        var details = panel.querySelector('[data-board-review-details]');
        var fileInput = customizer.querySelector('[data-cb-engraving-file]');
        var textInput = customizer.querySelector('[data-cb-engraving-text]');
        var placement = customizer.querySelector('[data-cb-engraving-placement]');
        var idInput = form.querySelector('[name="id"]');
        var productId = form.querySelector('[data-board-product]').value;
        var buttons = panel.querySelectorAll('[data-board-add]');
        var currentVariant = null;
        var previewUrl = '';
        var busy = false;
        var unresolved = false;
        var savedLine = null;
        var savedSignature = '';
        var pendingToken = '';

        function property(name, value) {
          var field = Array.from(form.elements).find(function (element) { return element.name === 'properties[' + name + ']'; });
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'properties[' + name + ']';
            form.appendChild(field);
          }
          field.value = value;
        }

        function selection() {
          var woods = {};
          customizer.querySelectorAll('[data-cb-wood-slot]').forEach(function (select) { woods[select.dataset.cbWoodSlot] = select.value; });
          return {
            design: panel.dataset.boardPanel,
            size: customizer.querySelector('[data-cb-size][aria-checked="true"]').dataset.cbSize,
            groove: customizer.querySelector('[data-cb-addon="groove"]').checked,
            engraving: customizer.querySelector('[data-cb-addon="engraving"]').checked,
            woods: woods
          };
        }

        function fileError() {
          if (fileInput.disabled || !fileInput.files.length) return '';
          var file = fileInput.files[0];
          if (!/\.(png|jpe?g|svg|pdf)$/i.test(file.name)) return 'Choose a PNG, JPG, SVG, or PDF artwork file.';
          if (!file.size || file.size > 20 * 1024 * 1024) return 'Choose a nonempty artwork file smaller than 20 MB.';
          return '';
        }

        function validationError(selected) {
          if (!currentVariant) return 'This configuration is not available to purchase online. Please request a custom order.';
          if (!currentVariant.available) return 'This configuration is sold out. Please choose another configuration.';
          if (selected.engraving && !textInput.value.trim() && !fileInput.files.length) return 'Add your inscription or upload artwork for the engraving.';
          return fileError();
        }

        function update() {
          if (busy) return;
          var selected = selection();
          currentVariant = resolve(catalog, selected, productId);
          idInput.value = currentVariant ? String(currentVariant.id) : '';
          idInput.disabled = !currentVariant || !currentVariant.available;
          fileInput.disabled = !selected.engraving;
          property('Engraving Text', selected.engraving ? textInput.value.trim() : '');
          property('Engraving Placement', selected.engraving ? placement.value : '');
          property('Juice Groove', selected.groove ? 'Yes' : 'No');
          property('Laser Engraving', selected.engraving ? 'Yes' : 'No');
          property('Artwork Filename', selected.engraving && fileInput.files.length ? fileInput.files[0].name : '');
          var existingRef = form.querySelector('[name="properties[Board Design Reference]"]');
          if (existingRef) existingRef.remove();
          var existingPrice = form.querySelector('[name="properties[Configured Total Price]"]');
          if (existingPrice) existingPrice.remove();
          var price = currentVariant ? formatter.format(currentVariant.price / 100) + ' ' + currency : 'Unavailable';
          panel.querySelectorAll('[data-product-price], [data-cb-summary-total]').forEach(function (el) { el.textContent = price; });
          customizer.querySelector('.dms-cb-summary__label').textContent = 'Board price';
          customizer.querySelectorAll('[data-cb-size]').forEach(function (pill) {
            var candidate = resolve(catalog, Object.assign({}, selected, { size: pill.dataset.cbSize }), productId);
            pill.querySelector('[data-price-size]').textContent = candidate ? formatter.format(candidate.price / 100) : 'Unavailable';
          });
          // Show the actual variant price difference for each optional extra.
          ['groove', 'engraving'].forEach(function (addon) {
            var without = resolve(catalog, Object.assign({}, selected, { [addon]: false }), productId);
            var withAddon = resolve(catalog, Object.assign({}, selected, { [addon]: true }), productId);
            var label = customizer.querySelector('[data-cb-addon="' + addon + '"]').closest('.dms-cb-addon-card').querySelector('.dms-cb-addon-card__price');
            label.textContent = without && withAddon ? (withAddon.price === without.price ? 'Included' : '+' + formatter.format((withAddon.price - without.price) / 100)) : 'Unavailable';
          });
          customizer.querySelector('[data-cb-summary-addons]').textContent = [selected.groove ? 'Juice groove' : '', selected.engraving ? 'Personal engraving' : ''].filter(Boolean).join(' · ') || 'No add-ons';
          var rows = [['Style', panel.querySelector('.product__title').textContent], ['Size', selected.size.replace('x', ' × ') + ' inches']];
          Object.keys(selected.woods).forEach(function (slot) { rows.push([slot, selected.woods[slot]]); });
          rows.push(['Juice groove', selected.groove ? 'Yes' : 'No'], ['Engraving', selected.engraving ? 'Yes' : 'No']);
          if (selected.engraving) rows.push(['Inscription', textInput.value.trim() || 'Artwork only'], ['Placement', placement.value]);
          panel.querySelector('[data-board-review-price]').textContent = price;
          details.replaceChildren();
          rows.forEach(function (row) {
            var term = document.createElement('dt');
            var value = document.createElement('dd');
            term.textContent = row[0];
            value.textContent = row[1];
            details.append(term, value);
          });
          panel.querySelector('[data-board-artwork-review]').hidden = !selected.engraving || !fileInput.files.length;
          var error = validationError(selected);
          status.dataset.state = error || unresolved ? 'error' : 'ready';
          status.textContent = unresolved ? 'We could not verify the last cart request. Open your cart to check it before trying again.' : error || 'Shipping and taxes calculated at checkout.';
          buttons.forEach(function (button) { button.disabled = !!error || unresolved; });
          // Uploaded artwork must be saved through Add to cart before using Shop Pay at checkout.
          express.hidden = !!error || unresolved || (selected.engraving && fileInput.files.length > 0);
        }

        fileInput.addEventListener('change', function () {
          if (previewUrl) URL.revokeObjectURL(previewUrl);
          var image = panel.querySelector('[data-board-artwork-preview]');
          var caption = panel.querySelector('[data-board-artwork-name]');
          image.hidden = true;
          image.removeAttribute('src');
          previewUrl = '';
          if (fileInput.files.length) {
            var file = fileInput.files[0];
            caption.textContent = file.name + (/\.pdf$/i.test(file.name) ? ' (PDF artwork attached)' : '');
            if (!fileError() && /\.(png|jpe?g|svg)$/i.test(file.name)) {
              previewUrl = URL.createObjectURL(file);
              image.src = previewUrl;
              image.hidden = false;
            }
          }
        });

        function signature(data) {
          return JSON.stringify(Array.from(data.entries()).filter(function (pair) { return pair[0] !== 'properties[_Board Configuration ID]'; }).map(function (pair) {
            return [pair[0], pair[1] instanceof File ? [pair[1].name, pair[1].size, pair[1].lastModified] : pair[1]];
          }));
        }

        async function request(path, options) {
          var controller = new AbortController();
          var timer = setTimeout(function () { controller.abort(); }, 25000);
          try {
            var response = await fetch(root + path, Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal }, options));
            var json = await response.json();
            if (!response.ok) {
              var error = new Error(json.description || json.message || 'Shopify could not process this request.');
              error.rejected = response.status >= 400 && response.status < 500;
              throw error;
            }
            return json;
          } finally { clearTimeout(timer); }
        }

        function verify(line, data) {
          if (!line || String(line.variant_id || line.id) !== idInput.value || line.quantity !== 1 || line.original_price !== currentVariant.price) return false;
          return Array.from(data.entries()).every(function (pair) {
            var match = pair[0].match(/^properties\[(.+)\]$/);
            if (!match || !pair[1]) return true;
            var stored = (line.properties || {})[match[1]];
            if (pair[1] instanceof File) return !pair[1].size || (typeof stored === 'string' && /^https:\/\//.test(stored));
            return stored === pair[1];
          });
        }

        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (busy || unresolved) return;
          update();
          if (validationError(selection()) || !form.reportValidity()) return;
          var data = new FormData(form);
          // Blank file inputs must not create phantom artwork properties.
          if (!fileInput.files.length || fileInput.disabled) data.delete(fileInput.name);
          var fingerprint = signature(data);
          if (!savedLine || fingerprint !== savedSignature) {
            pendingToken = window.crypto.randomUUID();
            property('_Board Configuration ID', pendingToken);
            data.set('properties[_Board Configuration ID]', pendingToken);
          }
          busy = true;
          buttons.forEach(function (button) { button.disabled = true; });
          express.hidden = true;
          shop.setAttribute('inert', '');
          shop.setAttribute('aria-busy', 'true');
          status.textContent = 'Saving your board and verifying its price and artwork…';
          var postAttempted = false;
          try {
            var cart = await request('cart.js');
            var line = savedLine && cart.items.find(function (item) { return item.key === savedLine.key; });
            if (!line || savedSignature !== fingerprint) {
              postAttempted = true;
              await request('cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
              cart = await request('cart.js');
              line = cart.items.find(function (item) { return (item.properties || {})['_Board Configuration ID'] === pendingToken; });
            }
            if (!verify(line, data)) {
              unresolved = true;
              throw new Error('The saved board did not match your configuration, price, or artwork. Review your cart before proceeding.');
            }
            savedLine = line;
            savedSignature = fingerprint;
            window.location.assign(root + 'cart');
          } catch (error) {
            // A lost response may still have added the item. Reconcile once, never blindly POST again.
            if (postAttempted && !error.rejected && !unresolved) {
              try {
                var recovered = await request('cart.js');
                var recoveredLine = recovered.items.find(function (item) { return (item.properties || {})['_Board Configuration ID'] === pendingToken; });
                if (verify(recoveredLine, data)) {
                  savedLine = recoveredLine;
                  savedSignature = fingerprint;
                  window.location.assign(root + 'cart');
                  return;
                }
                // Even an empty cart can race a pending upload; require cart review after an uncertain write.
                unresolved = true;
              } catch (recoveryError) { unresolved = true; }
            }
            busy = false;
            update();
            status.textContent = unresolved ? 'Your cart could not be verified. Check your cart before retrying to avoid a duplicate board.' : error.message || 'Unable to connect to Shopify. Please try again.';
            if (unresolved) {
              var link = document.createElement('a');
              link.href = root + 'cart';
              link.textContent = ' Review cart';
              status.appendChild(link);
            }
          } finally {
            busy = false;
            shop.removeAttribute('inert');
            shop.removeAttribute('aria-busy');
          }
        }, true);

        form.addEventListener('click', function (event) {
          if (!event.composedPath().some(function (node) { return node instanceof Element && node.matches('[data-board-express], shopify-accelerated-checkout'); })) return;
          update();
          if (busy || unresolved || validationError(selection()) || (selection().engraving && fileInput.files.length)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        // Bubble after the existing configurator so its estimate can never overwrite the confirmed price.
        customizer.addEventListener('dms:board:updated', update);
        panel.addEventListener('input', update);
        panel.addEventListener('change', update);
        panel.addEventListener('click', function (event) { if (event.target.closest('[data-cb-size]')) update(); });
        shop.addEventListener('click', function (event) { if (event.target.closest('[data-design-card], [data-switch-board]')) update(); });
        shop.addEventListener('change', function (event) { if (event.target.matches('[data-board-design]')) update(); });
        window.addEventListener('hashchange', update);
        update();
      });
    });
  }
  // Other theme scripts initialize the existing controls first.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { queueMicrotask(function () { init(document); }); });
  else queueMicrotask(function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { queueMicrotask(function () { init(event.target); }); });
})();
